module.exports = __webpack_public_path__ + "img/bothsides_1000.4bbafed2.png";